import { pushToChannel } from 'modules/session/actions'
import { useCallback, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { throttle } from 'throttle-debounce'

const TYPING_INDICATOR_TIMEOUT = 5000

const useTypingIndicators = ({ activeConversationId }) => {
  const dispatch = useDispatch()
  const typingTimeoutRef = useRef<number>()

  const endUserType = useSelector(state => state.session.endUser.type)

  const endUserId = useSelector(state => (
    state.session.endUser.id
  ))

  const sendTypingEvent = useCallback((typingEvent: 'started' | 'finished') => {
    dispatch(pushToChannel('chat', 'user', `typing:${typingEvent}`, {
      userId: endUserId,
      userType: endUserType,
      conversationId: activeConversationId,
      participants: []
    }))
  }, [activeConversationId, dispatch, endUserId, endUserType])

  const thottledTypingStarted = useMemo(
    () => throttle(TYPING_INDICATOR_TIMEOUT, false, () => sendTypingEvent('started')),
    [sendTypingEvent]
  )

  const sendTypingStarted = () => {
    thottledTypingStarted()

    if (typingTimeoutRef.current) {
      window.clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = window.setTimeout(
      () => sendTypingEvent('finished'),
      TYPING_INDICATOR_TIMEOUT
    )
  }

  const sendTypingFinished = () => {
    if (typingTimeoutRef.current) {
      window.clearTimeout(typingTimeoutRef.current)
      typingTimeoutRef.current = null
    }

    sendTypingEvent('finished')
  }


  return {
    sendTypingStarted,
    sendTypingFinished
  }
}

export default useTypingIndicators
